export const getUsgProductUrl = (productDetails) => {
  let usgProductImageUrl = '';
  if(productDetails?.customizationType !== "NULL" &&
    productDetails?.customizationInfo?.isUsgProduct &&
    productDetails?.customizationInfo?.previewImageUrl &&
    productDetails?.customizationInfo?.croppedPreviews?.scenePreview &&
    !productDetails?.customizationInfo?.isAssortedDesign
  ) {
    usgProductImageUrl = productDetails.customizationInfo.croppedPreviews.scenePreview;
  }
  return usgProductImageUrl;
}